module.exports = "/images/ny-blck-7.jpg";